import React from 'react';
import { exposeWrapped } from '@/utils';
const { Provider, Consumer } = React.createContext(false);
export default { Provider, Consumer };
export const disabling = exposeWrapped((Component) => function DisablingComponent(props) {
    return <Consumer>{(disabled) => <Component disabled={disabled} {...props}/>}</Consumer>;
});
